<template>
  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
    <!-- <div class="carousel-indicators">
      <button
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide-to="0"
        class="active"
        aria-current="true"
        aria-label="Slide 1"
      ></button>
      <button
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide-to="1"
        aria-label="Slide 2"
      ></button>
      
    </div> -->
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img :src="$t('Header.CarousalImg1')" class="d-none d-md-block img-fluid w-100"
          alt="Market Basket promotion: Spend $30 on P&G products and get a $10 Market Basket Gift Card. Visit www.PGMarketBasket.com." />
        <img
          :src="$route.name === 'FAQ' ? 'https://snippcheck.blob.core.windows.net/files/PG_2008946_MarketBasketEvergreen/banner-mb-faq.jpg' : $t('Header.CarousalmobileImg1')"
          class="d-md-none img-fluid w-100"
          alt="Market Basket promotion: Spend $30 on P&G products and get a $10 Market Basket Gift Card. Visit www.PGMarketBasket.com." />
      </div>
      <!-- <div class="carousel-item">
        <img
            :src="$t('Header.CarousalImg1')"
          class="d-none d-md-block img-fluid w-100"
          alt="banner1"
        />
        <img
          :src="$t('Header.CarousalmobileImg1')"
          class="d-md-none img-fluid w-100"
          alt="banner1"
        />
      </div>   -->
    </div>
    <!-- <a
      class="carousel-control-prev"
      href="#carouselExampleIndicators"
      role="button"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </a>
    <a
      class="carousel-control-next"
      href="#carouselExampleIndicators"
      role="button"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </a> -->
  </div>
</template>

<script>
export default {
  name: 'Carousel',
};
</script>

<style scoped>
/* Hide numbers in carousel indicators */
.carousel-indicators button {
  background-color: #fff;
  /* Optional: Change color if needed */
}

.carousel-indicators button::after {
  content: '';
  /* Remove the default text content */
}

.carousel-indicators button[data-bs-slide-to] {
  position: relative;
}

.carousel-indicators button[data-bs-slide-to]::after {
  display: none;
  /* Hide numbers */
}
</style>
